import { render, staticRenderFns } from "./textosIndex.vue?vue&type=template&id=0e7b0eb2&scoped=true&"
import script from "./textosIndex.vue?vue&type=script&lang=js&"
export * from "./textosIndex.vue?vue&type=script&lang=js&"
import style0 from "./textosIndex.vue?vue&type=style&index=0&id=0e7b0eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b0eb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
